import type {ChartRow} from '../health/chartSeries';
export function riskSignal(rows:ChartRow[],key:string){
 const measured=rows.filter(r=>r.methods?.[key]&&typeof (r as any)[key]==='number');
 const latest=measured.at(-1);if(!latest)return {value:null,change:null,from:null,to:null};
 const baseline=measured.find(r=>r.id!==latest.id&&r.t<latest.t&&r.sourceKind===latest.sourceKind&&r.methods?.[key]&&r.methods[key]===latest.methods?.[key]&&!(r.scopeHash&&r.scopeHash===latest.scopeHash&&(r as any)[key]!== (latest as any)[key]));
 return {value:(latest as any)[key] as number,change:baseline?(latest as any)[key]-(baseline as any)[key]:null,from:baseline?.label??null,to:latest.label};
}
export function CodeTrendGuide({rows,selected}:{rows:ChartRow[];selected:string[]}){
 const candidates=[
  {count:"ccAbove",key:"ccAbovePct",label:"Above path-complexity limit",unit:"of measured functions"},
  {count:"cognitiveAbove",key:"cognitiveAbovePct",label:"Above cognitive-complexity limit",unit:"of measured functions"},
  {count:"largeFunctions",key:"largeFunctionsPct",label:"Large functions",unit:"of measured functions"},
  {count:"cloneGroups",key:"duplicationPct",label:"Duplicated code",unit:"of measured lines"},
 ];
 const signals=candidates.filter(s=>selected.includes(s.count)&&!selected.includes(s.key)).flatMap(s=>{
  let index=rows.length-1;
  while(index>=0&&typeof (rows[index] as any)[s.count]!=='number')index--;
  const latest=rows[index];
  if(!latest?.methods?.[s.key]||typeof (latest as any)[s.key]!=='number')return [];
  return [{...s,result:riskSignal(rows.slice(0,index+1),s.key)}];
 }).filter(s=>s.result.value!==null);
 if(!signals.length)return null;
 return <span className="chart-context" aria-label="Context for selected measurements">
  {signals.map(s=><span key={s.key} title={`${s.unit}. ${s.result.change===null?'No comparable earlier measurement.':`${Math.abs(s.result.change).toFixed(2)} percentage points ${s.result.change===0?'unchanged':s.result.change<0?'lower':'higher'} than ${s.result.from}.`}`}><span>{s.result.value!.toFixed(2)}% {s.unit}</span></span>)}
 </span>;
}
